import trainingLibraryLocale from './en.json'

const en = {
  trainingLibrary: trainingLibraryLocale,
}

export default en
